import { BEIGE_500, CORAL_600, GRAY_900 } from 'constants/styling/theme'
import { Box, Stack, Typography } from '@mui/material'

import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined'

export const SectionWrapped: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Stack gap=".8rem" width="100%">
      {children}
    </Stack>
  )
}

/**
 * @interface Props for TopBarDropdownSectionItem component
 */
export interface TopbarProps {
  /** If true, the text will be lighter */
  isLight?: boolean
  /** If true, the item will show an external link icon */
  isExternalLink?: boolean
  /** If true, the item will show active state with background */
  isActive?: boolean
  /** If true, the item will use the mobile height */
  isMobile?: boolean
  /** The icon to display on the left side of the item */
  icon?: React.ReactNode
  /** The label to display */
  label?: string
  /** The icon to display on the right side of the item */
  endIcon?: React.ReactNode
  /** onClick action */
  onClick?: (e: React.MouseEvent<Element, MouseEvent>) => void
}

/**
 * @component SectionItem displayed TopBar dropdown menu
 * @example <SectionItem />
 */
export const SectionItem: React.FC<TopbarProps> = ({ isLight = false, isExternalLink = false, isActive = false, isMobile = false, icon, label, endIcon, onClick }) => {
  return (
    <Stack
      gap=".8rem"
      width="100%"
      padding=".4rem"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      onClick={onClick}
      sx={{
        boxSizing: 'border-box',
        height: isMobile ? '4.8rem' : '2.8rem',
        cursor: 'pointer',
        borderRadius: '.4rem',
        background: isActive ? BEIGE_500 : 'transparent',
        '&:hover': {
          background: BEIGE_500,
        },
      }}
    >
      <Stack gap=".8rem" flexDirection="row" alignItems="center">
        <Box width="1.8rem" height="1.8rem" sx={{ fontSize: '1.8rem' }}>
          {icon}
        </Box>

        <Typography className="section-item-label" variant="text-sm" fontWeight={isLight ? 350 : 550} color={GRAY_900}>
          {label}
        </Typography>
      </Stack>

      {isExternalLink && <OpenInNewOutlinedIcon sx={{ fontSize: '1.4rem', color: CORAL_600 }} />}

      {endIcon && endIcon}
    </Stack>
  )
}
